/**
 * Use this function in order to be able to mock the Date() constructor it for testing
 * @param  {...any} args
 * @returns Date: new Date(args)
 */
export function getNewDate(...args) {
  return new Date(...args);
}
